import { provideRouterStore } from '@ngrx/router-store';
import { provideState } from '@ngrx/store';
import { CustomSerializer, reducers, routerFeatureKey } from './router.reducer';

export const routerStoreProvider = () => [
  provideState(routerFeatureKey, reducers),
  provideRouterStore({
    serializer: CustomSerializer,
  }),
];
